import { render, staticRenderFns } from "./_dangerZone.vue?vue&type=template&id=92003aba&lang=pug&"
import script from "./_dangerZone.vue?vue&type=script&lang=js&"
export * from "./_dangerZone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports